import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import SafetyHuddleLayout from './SafetyHuddleLayout';
import SafetyHuddleHubPage from './SafetyHuddleHubPage';
import SafetyHuddleSectorPage from './SafetyHuddleSectorPage';
import SafetyHuddleFormPage from './SafetyHuddleFormPage';
import SafetyHuddleDashboardPage from './SafetyHuddleDashboardPage';
import SafetyHuddleOverviewDashboardPage from './SafetyHuddleOverviewDashboardPage';
import SafetyHuddleAdminFormPage from './SafetyHuddleAdminFormPage';
import SafetyHuddleHistoricoPage from './SafetyHuddleHistoricoPage';
import SafetyHuddleAdminSetoresPage from './SafetyHuddleAdminSetoresPage';
import SafetyHuddleOverviewCorporativoPage from './SafetyHuddleOverviewCorporativoPage';

/** Rotas do Safety Huddle — isolado do shell de Contratos (padrão ARCA). */
export default function SafetyHuddleModule() {
  return (
    <Routes>
      <Route path="/safety-huddle" element={<SafetyHuddleLayout />}>
        <Route index element={<SafetyHuddleHubPage />} />
        <Route path="dashboard" element={<SafetyHuddleOverviewDashboardPage />} />
        <Route path="corporativo" element={<SafetyHuddleOverviewCorporativoPage />} />
        <Route path="admin/setores" element={<SafetyHuddleAdminSetoresPage />} />
        <Route path="setores/:sectorId" element={<SafetyHuddleSectorPage />} />
        <Route path="setores/:sectorId/formularios/:templateId" element={<SafetyHuddleFormPage />} />
        <Route path="setores/:sectorId/dashboard/:templateId" element={<SafetyHuddleDashboardPage />} />
        <Route path="setores/:sectorId/historico/:templateId" element={<SafetyHuddleHistoricoPage />} />
        <Route path="setores/:sectorId/admin/:templateId" element={<SafetyHuddleAdminFormPage />} />
        <Route path="*" element={<Navigate to="/safety-huddle" replace />} />
      </Route>
    </Routes>
  );
}
